import React from 'react'
import styles from './index.module.scss'
import { Icon } from 'components/Icon'
import classNames from 'classnames'
import { appendLangParamToUrl } from 'utils/urls'
import environment from 'configuration/env'
import { useSelector } from 'react-redux'
import { IAppState } from 'reducers'
import { TranslationKeyPrefix, useTranslations } from 'hooks/useTranslations'

interface StepperProps {
  activeStep: number
  steps: string[]
}

const Stepper: React.FC<StepperProps> = ({ activeStep, steps }) => {
  const { getTranslationLiteral: tl } = useTranslations(TranslationKeyPrefix.AccountCreation)
  const { language } = useSelector((state: IAppState) => state.authentication)
  return (
    <div className={classNames('container-fluid', styles.stepProgress)}>
      <a
        href={appendLangParamToUrl(environment.dotComUrl, language)}
        className={styles.icon}
        aria-label={tl('christies')}
      >
        <Icon icon="christies" variant="dark" className={styles.icon} />
      </a>

      {activeStep > 0 && (
        <ol className={styles.stepsContainer}>
          {steps.map((step, index) => (
            <li
              key={step}
              className={styles.step}
              aria-current={index + 1 === activeStep ? 'step' : undefined}
            >
              <span className={styles.stepNumber}>
                {index + 1}
                <span className={styles.dot}>.</span>
              </span>
              <span className={styles.stepText}>{step}</span>
              {index + 1 < steps.length && <span className={styles.stepDot}></span>}
            </li>
          ))}
        </ol>
      )}
    </div>
  )
}

export default Stepper
